import { posthog } from "posthog-js";

const key = import.meta.env.VITE_POSTHOG_KEY;

if (key) {
  posthog.init(key, { person_profiles: "identified_only" });
}

export { posthog };
